/**
 * Card answers the server settles itself, without a reply from Kai: the
 * feature-request card's Upvote and Submit request (kai-intake CONTRACT
 * §5.2). The card changes in place, so no "Kai is typing" follows them.
 */
export const isSettledWidgetAnswer = (
  widgetType: unknown,
  action: unknown,
): boolean =>
  widgetType === "feature_requests" &&
  (action === "select" || action === "submit");
